﻿/*
 * Globalize Culture th-TH
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("th-TH", "default", {
    name: "th-TH",
    englishName: "Thai (Thailand)",
    nativeName: "ไทย (ไทย)",
    language: "th",
    numberFormat: {
      currency: {
        pattern: ["-$n", "$n"],
        symbol: "฿"
      }
    },
    calendars: {
      standard: {
        name: "ThaiBuddhist",
        firstDay: 1,
        days: {
          names: [
            "อาทิตย์",
            "จันทร์",
            "อังคาร",
            "พุธ",
            "พฤหัสบดี",
            "ศุกร์",
            "เสาร์"
          ],
          namesAbbr: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          namesShort: ["อ", "จ", "อ", "พ", "พ", "ศ", "ส"]
        },
        months: {
          names: [
            "มกราคม",
            "กุมภาพันธ์",
            "มีนาคม",
            "เมษายน",
            "พฤษภาคม",
            "มิถุนายน",
            "กรกฎาคม",
            "สิงหาคม",
            "กันยายน",
            "ตุลาคม",
            "พฤศจิกายน",
            "ธันวาคม",
            ""
          ],
          namesAbbr: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
            ""
          ]
        },
        eras: [{ name: "พ.ศ.", start: null, offset: -543 }],
        twoDigitYearMax: 2572,
        patterns: {
          d: "d/M/yyyy",
          D: "d MMMM yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "d MMMM yyyy H:mm",
          F: "d MMMM yyyy H:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      },
      Gregorian_Localized: {
        firstDay: 1,
        days: {
          names: [
            "อาทิตย์",
            "จันทร์",
            "อังคาร",
            "พุธ",
            "พฤหัสบดี",
            "ศุกร์",
            "เสาร์"
          ],
          namesAbbr: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
          namesShort: ["อ", "จ", "อ", "พ", "พ", "ศ", "ส"]
        },
        months: {
          names: [
            "มกราคม",
            "กุมภาพันธ์",
            "มีนาคม",
            "เมษายน",
            "พฤษภาคม",
            "มิถุนายน",
            "กรกฎาคม",
            "สิงหาคม",
            "กันยายน",
            "ตุลาคม",
            "พฤศจิกายน",
            "ธันวาคม",
            ""
          ],
          namesAbbr: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
            ""
          ]
        },
        patterns: {
          d: "d/M/yyyy",
          D: "'วัน'dddd'ที่' d MMMM yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "'วัน'dddd'ที่' d MMMM yyyy H:mm",
          F: "'วัน'dddd'ที่' d MMMM yyyy H:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "à¸Šà¹ˆà¸§à¸¢à¹€à¸«à¸¥à¸·à¸­à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡",
      AddNewTab: "à¹€à¸žà¸´à¹ˆà¸¡à¹à¸—à¹‡à¸šà¹ƒà¸«à¸¡à¹ˆ",
      Alerts: "à¹à¸ˆà¹‰à¸‡à¹€à¸•à¸·à¸­à¸™",
      ApplyFilter: "à¹ƒà¸Šà¹‰à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      Approve: "à¸­à¸™à¸¸à¸¡à¸±à¸•à¸´",
      Attachments: "à¹€à¸­à¸à¸ªà¸²à¸£à¹à¸™à¸š",
      Back: "à¸¢à¹‰à¸­à¸™à¸à¸¥à¸±à¸š",
      Basic: "à¸žà¸·à¹‰à¸™à¸à¸²à¸™",
      Between: "à¸£à¸°à¸«à¸§à¹ˆà¸²à¸‡",
      Book: "à¸ˆà¸­à¸‡",
      Cancel: "à¸¢à¸à¹€à¸¥à¸´à¸",
      Checked: "à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸šà¹à¸¥à¹‰à¸§",
      ClearFilter: "à¸¢à¸à¹€à¸¥à¸´à¸à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      Close: "à¸›à¸´à¸”",
      CloseCancelChanges:
        "à¸›à¸´à¸”à¹à¸¥à¸°à¸¢à¸à¹€à¸¥à¸´à¸à¸à¸²à¸£à¹€à¸›à¸¥à¸µà¹ˆà¸¢à¸™à¹à¸›à¸¥à¸‡",
      CloseSaveChanges:
        "à¸›à¸´à¸”à¹à¸¥à¸°à¸šà¸±à¸™à¸—à¸¶à¸à¸à¸²à¸£à¹€à¸›à¸¥à¸µà¹ˆà¸¢à¸™à¹à¸›à¸¥à¸‡",
      CloseTab: "à¸›à¸´à¸”à¹à¸—à¹‡à¸š",
      ColumnPersonalization:
        "à¸à¸³à¸«à¸™à¸”à¸„à¹ˆà¸²à¸„à¸­à¸¥à¸±à¸¡à¸™à¹Œà¹€à¸­à¸‡",
      Comments: "à¸„à¸§à¸²à¸¡à¸„à¸´à¸”à¹€à¸«à¹‡à¸™",
      Confirmation: "à¸à¸²à¸£à¸¢à¸·à¸™à¸¢à¸±à¸™",
      Contains: "à¸¡à¸µ",
      CreateTab: "à¸ªà¸£à¹‰à¸²à¸‡à¹à¸—à¹‡à¸šà¹ƒà¸«à¸¡à¹ˆ",
      Cut: "à¸•à¸±à¸”",
      Delete: "à¸¥à¸š",
      DiscardUndo: "à¸¢à¸à¹€à¸¥à¸´à¸/à¹€à¸¥à¸´à¸à¸—à¸³",
      DisplayDropDownList:
        "à¹à¸ªà¸”à¸‡à¸£à¸²à¸¢à¸à¸²à¸£à¹€à¸¥à¸·à¸­à¸à¹à¸šà¸šà¹€à¸¥à¸·à¹ˆà¸­à¸™à¸¥à¸‡",
      Displaying: "à¸à¸³à¸¥à¸±à¸‡à¹à¸ªà¸”à¸‡: ",
      DocWord: "à¹€à¸­à¸à¸ªà¸²à¸£",
      DoesNotContain: "à¹„à¸¡à¹ˆà¸¡à¸µ",
      DoesNotEndWith: "à¹„à¸¡à¹ˆà¸ˆà¸šà¸¥à¸‡à¸”à¹‰à¸§à¸¢",
      DoesNotEqual: "à¹„à¸¡à¹ˆà¹€à¸—à¹ˆà¸²à¸à¸±à¸š",
      DoesNotStartWith: "à¹„à¸¡à¹ˆà¹€à¸£à¸´à¹ˆà¸¡à¸•à¹‰à¸™à¸”à¹‰à¸§à¸¢",
      Download: "à¸”à¸²à¸§à¸™à¹Œà¹‚à¸«à¸¥à¸”",
      Duplicate: "à¸‹à¹‰à¸³",
      Edit: "à¹à¸à¹‰à¹„à¸‚",
      EitherSelectedorNotSelected:
        "à¹„à¸¡à¹ˆà¸§à¹ˆà¸²à¸ˆà¸°à¹€à¸¥à¸·à¸­à¸à¸«à¸£à¸·à¸­à¹„à¸¡à¹ˆà¹€à¸¥à¸·à¸­à¸",
      Email: "à¸­à¸µà¹€à¸¡à¸¥",
      EndsWith: "à¸ˆà¸šà¸”à¹‰à¸§à¸¢",
      EqualsStr: "à¹€à¸—à¹ˆà¸²à¸à¸±à¸š",
      ExpandCollapse: "à¸‚à¸¢à¸²à¸¢/à¸«à¸”",
      ExportFailed: "à¸ªà¹ˆà¸‡à¸­à¸­à¸à¸¥à¹‰à¸¡à¹€à¸«à¸¥à¸§",
      ExportToExcel: "à¸ªà¹ˆà¸‡à¸­à¸­à¸à¹„à¸›à¸¢à¸±à¸‡ Excel",
      FileInUse:
        "à¹„à¸Ÿà¸¥à¹Œà¸—à¸µà¹ˆà¸£à¸°à¸šà¸¸à¸à¸³à¸¥à¸±à¸‡à¹ƒà¸Šà¹‰à¸­à¸¢à¸¹à¹ˆ",
      FileInUseDetail:
        "à¸›à¸´à¸”à¹„à¸Ÿà¸¥à¹Œà¹ƒà¸™à¹à¸­à¸žà¸žà¸¥à¸´à¹€à¸„à¸Šà¸±à¹ˆà¸™à¸—à¸µà¹ˆà¸à¸³à¸¥à¸±à¸‡à¹ƒà¸Šà¹‰à¸­à¸¢à¸¹à¹ˆ à¸«à¸£à¸·à¸­à¸£à¸°à¸šà¸¸à¸Šà¸·à¹ˆà¸­à¹„à¸Ÿà¸¥à¹Œà¸—à¸µà¹ˆà¹à¸•à¸à¸•à¹ˆà¸²à¸‡à¸­à¸­à¸à¹„à¸›",
      Filter: "à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      FilterMenu: "à¹€à¸¡à¸™à¸¹à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      FilterOptions: "à¸•à¸±à¸§à¹€à¸¥à¸·à¸­à¸à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      FilterWithinResults:
        "à¸•à¸±à¸§à¸à¸£à¸­à¸‡à¸ à¸²à¸¢à¹ƒà¸™à¸œà¸¥à¸¥à¸±à¸žà¸˜à¹Œ",
      First: "à¸„à¸£à¸±à¹‰à¸‡à¹à¸£à¸",
      FirstView: "à¸¡à¸¸à¸¡à¸¡à¸­à¸‡à¸„à¸£à¸±à¹‰à¸‡à¹à¸£à¸",
      Folder: "à¹‚à¸Ÿà¸¥à¹€à¸”à¸­à¸£à¹Œ",
      ForgotPassword:
        "à¸¥à¸·à¸¡à¸£à¸«à¸±à¸ªà¸œà¹ˆà¸²à¸™à¸‚à¸­à¸‡à¸„à¸¸à¸“à¸«à¸£à¸·à¸­",
      Forward: "à¹„à¸›à¸‚à¹‰à¸²à¸‡à¸«à¸™à¹‰à¸²",
      GetMoreRows: "à¹€à¸žà¸´à¹ˆà¸¡à¹à¸–à¸§à¸¡à¸²à¸à¸‚à¸¶à¹‰à¸™",
      GreaterThan: "à¸¡à¸²à¸à¸à¸§à¹ˆà¸²",
      GreaterThanOrEquals:
        "à¸¡à¸²à¸à¸à¸§à¹ˆà¸²à¸«à¸£à¸·à¸­à¹€à¸—à¹ˆà¸²à¸à¸±à¸š",
      GridSettings: "à¸à¸²à¸£à¸•à¸±à¹‰à¸‡à¸„à¹ˆà¸²à¸à¸£à¸´à¸”",
      GroupSelection: "à¸à¸²à¸£à¹€à¸¥à¸·à¸­à¸à¸à¸¥à¸¸à¹ˆà¸¡",
      Help: "à¸Šà¹ˆà¸§à¸¢à¹€à¸«à¸¥à¸·à¸­",
      HideColumn: "à¸‹à¹ˆà¸­à¸™à¸„à¸­à¸¥à¸±à¸¡à¸™à¹Œ",
      IsEmpty: "à¸§à¹ˆà¸²à¸‡",
      IsNotEmpty: "à¹„à¸¡à¹ˆà¸§à¹ˆà¸²à¸‡",
      Last: "à¸„à¸£à¸±à¹‰à¸‡à¸ªà¸¸à¸”à¸—à¹‰à¸²à¸¢",
      LastView: "à¸¡à¸¸à¸¡à¸­à¸‡à¸„à¸£à¸±à¹‰à¸‡à¸ªà¸¸à¸”à¸—à¹‰à¸²à¸¢",
      LaunchActivate: "à¹€à¸£à¸´à¹ˆà¸¡/à¹€à¸›à¸´à¸”à¹ƒà¸Šà¹‰à¸‡à¸²à¸™",
      LessThan: "à¸™à¹‰à¸­à¸¢à¸à¸§à¹ˆà¸²",
      LessThanOrEquals:
        "à¸™à¹‰à¸­à¸¢à¸à¸§à¹ˆà¸²à¸«à¸£à¸·à¸­à¹€à¸—à¹ˆà¸²à¸à¸±à¸š",
      Links: "à¸¥à¸´à¸‡à¸„à¹Œ",
      ListTabs: "à¸£à¸²à¸¢à¸Šà¸·à¹ˆà¸­à¹à¸—à¹‡à¸šà¸—à¸±à¹‰à¸‡à¸«à¸¡à¸”",
      LoadingItem: "à¸à¸³à¸¥à¸±à¸‡à¹‚à¸«à¸¥à¸”à¹„à¸­à¹€à¸—à¹‡à¸¡ ",
      Maintenance: "à¸‹à¹ˆà¸­à¸¡à¸šà¸³à¸£à¸¸à¸‡",
      Menu: "à¹€à¸¡à¸™à¸¹",
      New: "à¹ƒà¸«à¸¡à¹ˆ",
      Next: "à¸•à¹ˆà¸­à¹„à¸›",
      NextView: "à¸¡à¸¸à¸¡à¸¡à¸­à¸‡à¸•à¹ˆà¸­à¹„à¸›",
      No: "à¹„à¸¡à¹ˆ",
      NotChecked: "à¹„à¸¡à¹ˆà¹„à¸”à¹‰à¸•à¸£à¸§à¸ˆà¸ªà¸­à¸š",
      Notes: "à¸«à¸¡à¸²à¸¢à¹€à¸«à¸•à¸¸",
      NotSelected: "à¹„à¸¡à¹ˆà¹„à¸”à¹‰à¹€à¸¥à¸·à¸­à¸",
      Of: " à¸‚à¸­à¸‡ ",
      Ok: "à¹‚à¸­à¹€à¸„",
      Open: "à¹€à¸›à¸´à¸”",
      Password: "à¸£à¸«à¸±à¸ªà¸œà¹ˆà¸²à¸™",
      Paste: "à¸§à¸²à¸‡",
      Phone: "à¹‚à¸—à¸£à¸¨à¸±à¸žà¸—à¹Œ",
      PleaseWait: "à¸à¸£à¸¸à¸“à¸²à¸£à¸­",
      Previous: "à¸à¹ˆà¸­à¸™à¸«à¸™à¹‰à¸²",
      PreviousView: "à¸¡à¸¸à¸¡à¸¡à¸­à¸‡à¸à¹ˆà¸­à¸™à¸«à¸™à¹‰à¸²",
      Print: "à¸žà¸´à¸¡à¸žà¹Œ",
      Queries: "à¸„à¸³à¸–à¸²à¸¡",
      Redo: "à¸—à¸³à¸‹à¹‰à¸³",
      Refresh: "à¸£à¸µà¹€à¸Ÿà¸£à¸Š",
      Reject: "à¸›à¸à¸´à¹€à¸ªà¸˜",
      RememberMe:
        "à¸ˆà¸³à¸‰à¸±à¸™à¹ƒà¸™à¸„à¸­à¸¡à¸žà¸´à¸§à¹€à¸•à¸­à¸£à¹Œà¹€à¸„à¸£à¸·à¹ˆà¸­à¸‡à¸™à¸µà¹‰",
      Reports: "à¸£à¸²à¸¢à¸‡à¸²à¸™",
      Reset: "à¸£à¸µà¹€à¸‹à¹‡à¸—",
      Review: "à¸—à¸šà¸—à¸§à¸™",
      RunFilter: "à¸£à¸±à¸™à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      RunJob: "à¸£à¸±à¸™à¸ˆà¹‡à¸­à¸š",
      Save: "à¸šà¸±à¸™à¸—à¸¶à¸",
      SaveBeforeClosing: "à¸šà¸±à¸™à¸—à¸¶à¸à¸à¹ˆà¸­à¸™à¸›à¸´à¸”",
      SavedFilters: "à¸•à¸±à¸§à¸à¸£à¸­à¸‡à¸—à¸µà¹ˆà¸šà¸±à¸™à¸—à¸¶à¸à¹à¸¥à¹‰à¸§",
      SaveSubmit: "à¸šà¸±à¸™à¸—à¸¶à¸/à¸ªà¹ˆà¸‡",
      ScreenDesign: "à¸”à¸µà¹„à¸‹à¸™à¹Œà¸«à¸™à¹‰à¸²à¸ˆà¸­",
      Search: "à¸„à¹‰à¸™à¸«à¸²",
      SelectContents: "à¹€à¸¥à¸·à¸­à¸à¹€à¸™à¸·à¹‰à¸­à¸«à¸²",
      SelectDate: "à¹€à¸¥à¸·à¸­à¸à¸§à¸±à¸™à¸—à¸µà¹ˆ",
      SelectDeselect:
        "à¹€à¸¥à¸·à¸­à¸/à¹„à¸¡à¹ˆà¹€à¸¥à¸·à¸­à¸ à¸—à¸±à¹‰à¸‡à¸«à¸¡à¸”",
      Selected: "à¹€à¸¥à¸·à¸­à¸à¹à¸¥à¹‰à¸§: ",
      ServerName: "à¸Šà¸·à¹ˆà¸­à¹€à¸‹à¸´à¸£à¹Œà¸Ÿà¹€à¸§à¸­à¸£à¹Œ",
      Settings: "à¸à¸²à¸£à¸•à¸±à¹‰à¸‡à¸„à¹ˆà¸²",
      ShowFilterRow: "à¹à¸ªà¸”à¸‡à¹à¸–à¸§à¸•à¸±à¸§à¸à¸£à¸­à¸‡",
      SignIn: "à¸¥à¸‡à¸Šà¸·à¹ˆà¸­à¹€à¸‚à¹‰à¸²à¹ƒà¸Šà¹‰",
      SortAscending:
        "à¹€à¸£à¸µà¸¢à¸‡à¸¥à¸³à¸”à¸±à¸šà¸ˆà¸²à¸à¸™à¹‰à¸­à¸¢à¹„à¸›à¸¡à¸²à¸",
      SortDescending:
        "à¹€à¸£à¸µà¸¢à¸‡à¸¥à¸³à¸”à¸±à¸šà¸ˆà¸²à¸à¸¡à¸²à¸à¹„à¸›à¸™à¹‰à¸­à¸¢",
      Spreadsheet: "à¸ªà¹€à¸›à¸£à¸”à¸Šà¸µà¸—",
      StartsWith: "à¹€à¸£à¸´à¹ˆà¸¡à¸•à¹‰à¸™à¸”à¹‰à¸§à¸¢",
      StatusIndicator: "à¸•à¸±à¸§à¸Šà¸µà¹‰à¸§à¸±à¸”à¸ªà¸–à¸²à¸™à¸°",
      Tasks: "à¸‡à¸²à¸™",
      Today: "à¸§à¸±à¸™à¸™à¸µà¹‰",
      Translate: "à¹à¸›à¸¥",
      UserID: "User ID",
      Utilities: "à¸­à¸¸à¸›à¸à¸£à¸“à¹Œ",
      Yes: "à¹ƒà¸Šà¹ˆ",
      Page: "à¸«à¸™à¹‰à¸²",
      Rows: "à¹à¸–à¸§",
      ShowingAll: "à¹à¸ªà¸”à¸‡à¸—à¸±à¹‰à¸‡à¸«à¸¡à¸”",
      SessionNavigation: "à¹€à¸™à¸§à¸´à¹€à¸à¸Šà¸±à¹ˆà¸™à¹€à¸‹à¸ªà¸‹à¸±à¹ˆà¸™",
      ListAllMenuItems:
        "à¸£à¸²à¸¢à¸Šà¸·à¹ˆà¸­à¸£à¸²à¸¢à¸à¸²à¸£à¸•à¹ˆà¸²à¸‡à¹† à¸—à¸±à¹‰à¸‡à¸«à¸¡à¸”à¹ƒà¸™à¹€à¸¡à¸™à¸¹",
      NoRecordsFound: "à¹„à¸¡à¹ˆà¸žà¸šà¸šà¸±à¸™à¸—à¸¶à¸",
      SearchTree: "à¸à¸²à¸£à¸„à¹‰à¸™à¸«à¸²à¹à¸šà¸šà¸•à¹‰à¸™à¹„à¸¡à¹‰",
      Clear: "à¸¥à¹‰à¸²à¸‡",
      DrillDown: "à¹€à¸ˆà¸²à¸°à¸‚à¹‰à¸­à¸¡à¸¹à¸¥",
      Required: "à¸•à¹‰à¸­à¸‡à¸à¸£à¸­à¸à¸Šà¹ˆà¸­à¸‡à¸™à¸µà¹‰",
      Available: "à¸¡à¸µ:",
      Add: "à¹€à¸žà¸´à¹ˆà¸¡",
      MoveDown: "à¹€à¸¥à¸·à¹ˆà¸­à¸™à¸¥à¸‡",
      MoveUp: "à¹€à¸¥à¸·à¹ˆà¸­à¸™à¸‚à¸¶à¹‰à¸™",
      Remove: "à¹€à¸­à¸²à¸­à¸­à¸",
      LastYear: "à¸›à¸µà¸—à¸µà¹ˆà¹à¸¥à¹‰à¸§",
      NextMonth: "à¹€à¸”à¸·à¸­à¸™à¸«à¸™à¹‰à¸²",
      NextWeek: "à¸ªà¸±à¸›à¸”à¸²à¸«à¹Œà¸«à¸™à¹‰à¸²",
      NextYear: "à¸›à¸µà¸«à¸™à¹‰à¸²",
      OneMonthAgo: "à¸«à¸™à¸¶à¹ˆà¸‡à¹€à¸”à¸·à¸­à¸™à¸œà¹ˆà¸²à¸™à¹„à¸›",
      OneWeekAgo: "à¸«à¸™à¸¶à¹ˆà¸‡à¸ªà¸±à¸›à¸”à¸²à¸«à¹Œà¸œà¹ˆà¸²à¸™à¹„à¸›",
      SixMonthsAgo: "à¸«à¸à¹€à¸”à¸·à¸­à¸™à¸œà¹ˆà¸²à¸™à¹„à¸›",
      Time: "à¹€à¸§à¸¥à¸²",
      CannotBeSelected:
        "à¹„à¸¡à¹ˆà¸ªà¸²à¸¡à¸²à¸£à¸–à¹€à¸¥à¸·à¸­à¸à¹à¸–à¸§à¸™à¸µà¹‰à¹„à¸”à¹‰",
      ResetToDefault:
        "à¸£à¸µà¹€à¸‹à¹‡à¸—à¹„à¸›à¸—à¸µà¹ˆà¹€à¸¥à¸¢à¹Œà¹€à¸­à¸²à¸—à¹Œà¸—à¸µà¹ˆà¸•à¸±à¹‰à¸‡à¸„à¹ˆà¸²à¹„à¸§à¹‰",
      CloseOtherTabs: "à¸›à¸´à¸”à¹à¸—à¹‡à¸šà¸­à¸·à¹ˆà¸™",
      EmailValidation: "à¹ƒà¸ªà¹ˆà¸­à¸µà¹€à¸¡à¸¥à¸—à¸µà¹ˆà¸–à¸¹à¸à¸•à¹‰à¸­à¸‡",
      UrlValidation: "à¹ƒà¸ªà¹ˆ URL à¸—à¸µà¹ˆà¸–à¸¹à¸à¸•à¹‰à¸­à¸‡",
      EndofResults: "à¸ªà¸´à¹‰à¸™à¸ªà¸¸à¸”à¸œà¸¥à¸¥à¸±à¸žà¸˜à¹Œ",
      More: "à¹€à¸žà¸´à¹ˆà¸¡à¹€à¸•à¸´à¸¡...",
      RecordsPerPage: "à¸ˆà¸³à¸™à¸§à¸™à¸šà¸±à¸™à¸—à¸¶à¸à¸•à¹ˆà¸­à¸«à¸™à¹‰à¸²",
      Maximize: "à¹€à¸žà¸´à¹ˆà¸¡",
      Minimize: "à¸¥à¸”"
    }
  });
})(this);
